import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from '../../../utils/axios';
import { AxiosResponse } from 'axios';
import { API_URL } from '../../../constants';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import InventoryTransferDetails from './InventoryTransferDetails';
import { InventoryTransfer } from '../../../services/inventory/types';

const InventoryTransferDetailPage: React.FC = () => {
  const { inventoryTransferId } = useParams<{ inventoryTransferId: string }>();
  const history = useHistory();
  const [transfer, setTransfer] = useState<InventoryTransfer | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTransfer = async () => {
      if (!inventoryTransferId) return;

      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(`${API_URL}/inventory/transfers/${inventoryTransferId}`);
        setTransfer((response as AxiosResponse<InventoryTransfer>).data);
      } catch (error) {
        console.error('Error fetching inventory transfer:', error);
        setError('Failed to load inventory transfer details');
      } finally {
        setLoading(false);
      }
    };

    fetchTransfer();
  }, [inventoryTransferId]);

  const handleBack = () => {
    history.push('/inventory/transfers');
  };

  if (loading) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={handleBack} sx={{ mb: 2 }}>
          Back to Transfers
        </Button>
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  if (!transfer) {
    return (
      <Box sx={{ p: 3 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={handleBack} sx={{ mb: 2 }}>
          Back to Transfers
        </Button>
        <Typography variant="h6">Inventory transfer not found</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Button startIcon={<ArrowBackIcon />} onClick={handleBack} variant="outlined">
          Back to Transfers
        </Button>
      </Box>
      <InventoryTransferDetails transfer={transfer} />
    </Box>
  );
};

export default InventoryTransferDetailPage;
